import { render } from "./LPWidget.vue?vue&type=template&id=1079f4da&ts=true"
import script from "./LPWidget.vue?vue&type=script&lang=ts"
export * from "./LPWidget.vue?vue&type=script&lang=ts"

import "./LPWidget.vue?vue&type=style&index=0&id=1079f4da&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__